// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	$w("#readMoreButton").onClick(() => {
        $w("#PreloaderStateBox").changeState("expandedState");
    });

    $w("#readLessButton").onClick(() => {
        $w("#PreloaderStateBox").changeState("collapsedState");
    });
});